<form>
  <input id="FileUploader" type="file" (change)="uploadPhoto($event)" style="display:none">
  <input id="PhotoCapture" type="file" capture="environment" accept="image/*" (change)="uploadPhoto($event)" style="display:none">
</form>
<canvas id="canvas" #myCanvas style="display: none"></canvas>
